import React, { useState, useEffect } from 'react'
import { Prompt as ReactPrompt } from 'react-router-dom'

const useUnsavedChangesWarning = (msg = 'Tem certeza que deseja sair? Seus dados podem não ter sido salvos.') => {
  const [isDirty, setDirty] = useState(false)
  const [message, setMessage] = useState(msg)

  useEffect(() => {
    //Detecting browser closing
    window.onbeforeunload = isDirty && (() => message)

    return () => {
      window.onbeforeunload = null
    }
  }, [isDirty, message])

  const Prompt = <ReactPrompt when={isDirty} message={message} />

  return { Prompt, setDirty, setMessage }
}

export default useUnsavedChangesWarning
